export const anchorLinks = [
  {
    anchor: 'team',
    alias: '#team',
    title: 'Speakers',
  },
  {
    anchor: 'program',
    alias: '#program',
    title: 'Agenda',
  },
  {
    anchor: 'address',
    alias: '#address',
    title: 'How to find us',
  },
];

export const anchorLinksForHomePage = [
  {
    anchor: 'team',
    alias: '#team',
    title: 'Speakers',
  },
  {
    anchor: 'event-locations',
    alias: '#event-locations',
    title: 'Event locations',
  },
  {
    anchor: 'about-organizer',
    alias: '#about-organizer',
    title: 'About the organizer',
  },
];
